import type { ReactElement } from "react";

import SignalsCreateViewContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsCreateView/SignalsCreateViewContainer";
import type {
    SignalsManagementProps,
} from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagement/SignalsManagementContainer";
import SignalsManagementContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagement/SignalsManagementContainer";
import SignalsUpdateViewContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsUpdateView/SignalsUpdateViewContainer";
import type Signal from "app/pages/sales-intelligence/sub-modules/signals/models/core/Signal";
import type CreateViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-management/CreateViewProps";
import type EditViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-management/EditViewProps";

interface Props extends Omit<SignalsManagementProps, "createView" | "editView"> {
    onSignalCreateSuccess?: (signal: Signal) => void;
    onSignalUpdateSuccess?: (signal: Signal) => void;
}

const BaseSignalsManagementContainer = ({
    onSignalCreateSuccess,
    onSignalUpdateSuccess,
    ...signalsManagementProps
}: Props): ReactElement => {
    function initSignalCreateSuccess(successCb?: VoidFunction) {
        return (signal: Signal) => {
            successCb?.();

            onSignalCreateSuccess?.(signal);
        };
    }

    function initSignalUpdateSuccess(successCb?: VoidFunction) {
        return (signal: Signal) => {
            successCb?.();

            onSignalUpdateSuccess?.(signal);
        };
    }

    const CreateView = (props: CreateViewProps) => {
        return (
            <SignalsCreateViewContainer
                viewModel={props.viewModel}
                onCreateSuccess={initSignalCreateSuccess(props.onSubmitSuccess)}
            />
        );
    };

    const EditView = (props: EditViewProps) => {
        return (
            <SignalsUpdateViewContainer
                uiSignal={props.uiSignal}
                onUpdateSuccess={initSignalUpdateSuccess(props.onSubmitSuccess)}
            />
        );
    };

    return (
        <SignalsManagementContainer
            {...signalsManagementProps}
            createView={CreateView}
            editView={EditView}
        />
    );
};

export default BaseSignalsManagementContainer;
